var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { attrs: { id: "list-tasks" } }, [
    _c("li", [
      _c("div", { staticClass: "oblea", on: { click: _vm.clickOblea } }, [
        _c("div", { attrs: { id: "titulo-container" } }, [
          _c("span", { attrs: { id: "titulo" } }, [
            _vm._v(_vm._s(_vm.item.Nombre))
          ])
        ]),
        _vm._v(" "),
        _c("div", { attrs: { id: "container" } }, [
          _c("div", { attrs: { id: "imagen-container" } }, [
            _c("img", {
              staticStyle: { width: "80px" },
              attrs: { id: "imagenProducto", src: _vm.imagenProducto }
            })
          ]),
          _vm._v(" "),
          _c("div", { attrs: { id: "texto" } }, [
            _c(
              "p",
              { staticStyle: { "font-size": "10px", "font-weight": "400" } },
              [_vm._v("Precio normal:")]
            ),
            _vm._v(" "),
            _c(
              "p",
              { staticStyle: { "font-size": "10px", "font-weight": "400" } },
              [
                _vm._v(
                  "$" +
                    _vm._s(_vm._f("formatMoney")(_vm.item.PrecioHabitual)) +
                    " "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "p",
              {
                staticStyle: {
                  "font-size": "11px",
                  "font-weight": "500",
                  "margin-top": "10px"
                }
              },
              [_vm._v("Promoción:")]
            ),
            _vm._v(" "),
            _c(
              "p",
              { staticStyle: { "font-size": "11px", "font-weight": "500" } },
              [
                _vm._v(
                  "$" +
                    _vm._s(_vm._f("formatMoney")(_vm.item.PrecioPromocional)) +
                    " "
                )
              ]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77b08c3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77b08c3e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/home/itemPromocionHome.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-77b08c3e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/home/itemPromocionHome.vue
// module chunks = 0